import { Icon, Input, InputNumber } from 'antd'
import React from 'react'
import { CustomCol, CustomRow } from '../../../../../components/Custom'
const actionBtnStyle = {
    fontSize: 22,
    cursor: 'pointer',
    color: '#999'
}
class MerchantSplitBill extends React.Component{
    counter = 1

    handleAdd = () => {
        let value = this.props.value || []
        value.push({__counter: this.counter++})
        this.props.onChange && this.props.onChange(value)
    }
    
    handleMinus = (key) => {
        let value = this.props.value || []
        value = value.filter(e => e.__counter !== key)
        this.props.onChange && this.props.onChange(value)
    }

    handleInputChange = (ev, key, type) => {
        console.log(ev)
        let value = this.props.value || []
        value = value.map(e => {
            if (e.__counter === key) {
                e[type] = ev
            }
            return e
        })
        this.props.onChange && this.props.onChange(value)
    }

    renderItem(e) {
        const labelWidth = 100
         
        return (
            <CustomRow divider key={e.__counter}>
                <CustomCol labelStyle={{ width: labelWidth }} label="商户号">
                    <Input placeholder="请输入" value={e.mid} onChange={(ev) => this.handleInputChange(ev.target.value, e.__counter, 'mid')} />
                </CustomCol>
                <CustomCol labelStyle={{ width: labelWidth }} label="分账比例" extra="提示">
                    <InputNumber
                        min={0}
                        max={1} 
                        value={e.scale}
                        onChange={(ev) => this.handleInputChange(ev, e.__counter, 'scale')}
                    />
                </CustomCol>
                <Icon 
                    type="minus-circle" 
                    style={{...actionBtnStyle, marginLeft:3, marginTop:7}} 
                    onClick={() => this.handleMinus(e.__counter)}
                />
            </CustomRow>
        )
    }

    render(){

        let list = this.props.value || []
        list = list.map(e => {
            if (!e.__counter) {
                e.__counter = this.counter++
            }
            return e
        })
        return (
            <div className="">
                {list.map(e => this.renderItem(e))}
                <div style={{textAlign: 'center', paddingTop: 10}}>
                    <Icon type="plus-circle" onClick={this.handleAdd} style={actionBtnStyle} />
                </div>
            </div>
        )
    }
}

export default MerchantSplitBill


// WEBPACK FOOTER //
// ./src/page/Merchant/components/ManageAdd/components/SplitBillView.jsx